/// FOURJS_START_COPYRIGHT(D,2025)
/// Property of Four Js*
/// (c) Copyright Four Js 2025, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum(
  "ApplicationStateChangedCommand",
  ["CommandBase"],
  /**
   * @param {gbc} context
   * @param {classes} cls
   */
  function (context, cls) {
    /**
     * ApplicationStateChanged command.
     * @class ApplicationStateChangedCommand
     * @memberOf classes
     * @extends classes.CommandBase
     */
    cls.ApplicationStateChangedCommand = context.oo.Class(cls.CommandBase, function ($super) {
      return /** @lends classes.ApplicationStateChangedCommand.prototype */ {
        __name: "ApplicationStateChangedCommand",

        /**
         * @param {classes.VMApplication} app owner
         * @param {String[]} actionList list of actions to execute
         */
        constructor: function (app, actionList) {
          $super.constructor.call(this, app, null);
          this._actionList = actionList;
        },

        /**
         * @inheritDoc
         */
        execute: function () {
          // Tell the VM to execute the action
          this._app.action.executeActionByName("applicationstatechanged");
          return true;
        }
      };
    });
  }
);
